import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-163">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-164">
        <ShieldCheck className="w-16 h-16 text-gold mx-auto mb-4" data-id="element-165" />
        <h2 className="text-2xl font-bold text-navy mb-2" data-id="element-166">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="text-slate-600 mb-6" data-id="element-167">
          Abrí los tomos. Revisá el contenido. Explorá todo el sistema. Si el
          contenido no coincide con lo que describimos, te devolvemos el 100% de
          tu dinero. Sin formularios. Sin complicaciones.
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-slate-700" data-id="element-168">
          <span className="bg-white px-3 py-1 rounded-full border border-slate-200" data-id="element-169">
            Devolución del 100%
          </span>
          <span className="bg-white px-3 py-1 rounded-full border border-slate-200" data-id="element-170">
            Sin formularios, sin drama
          </span>
          <span className="bg-white px-3 py-1 rounded-full border border-slate-200" data-id="element-171">
            Tasa de devoluciones: menos del 1%
          </span>
        </div>
      </div>
    </section>;
}